import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import PricingSelectionComponent from 'components/pricing/PricingSelectionComponent'
import PlayersSelectionComponent from 'components/players/PlayersSelectionComponent'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class NewPoolTransactionModal extends React.Component {
  static propTypes = {
    table: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    players: PropTypes.array.isRequired,
    pricings: PropTypes.array.isRequired,
    currentPricing: PropTypes.object.isRequired,
    createTransactionForPool: PropTypes.func.isRequired
  }
  state = {
    pricing: null,
    players: []
  }
  handleCreateTransactionForPool = () => {
    const { table, currentUser } = this.props
    const { pricing, players } = this.state
    this.props.createTransactionForPool(table, pricing, players, currentUser)
  }
  handlePricingChange = pricing => {
    this.setState({ pricing: pricing })
  }
  handlePlayerChange = (index, count) => {
    const newState = { ...this.state }
    newState.players[index].count = count
    this.setState(newState)
  }
  componentDidMount() {
    if (this.props.players && this.props.currentPricing) {
      const playersTab = this.props.players.map(p => ({
        ...p,
        count: p.name === 'Normal' ? 1 : 0
      }))
      this.setState({
        players: _.orderBy(playersTab, ['order'], ['asc']),
        pricing: this.props.currentPricing
      })
    }
  }
  render() {
    const { table, pricings } = this.props
    const { players, pricing } = this.state
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleCreateTransactionForPool}
        title={`Ouvrir ${table.name}`}
        showOk>
        <Grid container direction="row" justify="center">
          <Grid item xs={12}>
            <Typography variant="title" gutterBottom>
              {' '}
              Choix du tarif{' '}
            </Typography>
            <Divider />
          </Grid>
          <PricingSelectionComponent
            selectedPricing={pricing}
            pricings={pricings}
            onChange={this.handlePricingChange}
          />
          <Grid item xs={12}>
            <Typography variant="title" gutterBottom>
              {' '}
              Joueurs{' '}
            </Typography>
            <Divider />
          </Grid>

          <PlayersSelectionComponent
            onChange={this.handlePlayerChange}
            players={players}
          />
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(NewPoolTransactionModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/NewPoolTransactionModal.js